<ion-row>
  <ion-col *ngIf="valgtDagAnlegg && _chartTypes.Dag.active" size="12">
    <app-forbruk-day
      [valgtAnlegg]="valgtDagAnlegg"
      [selectedDate]="selectedDateDay"
    ></app-forbruk-day>
  </ion-col>

  <ion-col *ngIf="valgtTimeAnlegg && _chartTypes.Time.active" size="12">
    <app-forbruk-hour
      [valgtAnlegg]="valgtTimeAnlegg"
      [selectedDate]="selectedDateHour"
    ></app-forbruk-hour>
  </ion-col>
</ion-row>
